/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { gettingStartedRequestTypesEntryPoint } from '@jira/spa-apps__servicedesk-getting-started-page/src/gettingStartedRequestTypesEntryPoint.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { RequestTypesSkeleton } from '@jira/platform__skeletons/src/ui/getting-started-page/RequestTypesSkeleton.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskIssueTypesResource } from '@jira/router-resources__service-desk-issue-types/src/servicedeskIssueTypesResource.tsx';
import { servicedeskPortalGroupsResource } from '@jira/router-resources__service-desk-portal-groups/src/servicedeskPortalGroupsResource.tsx';
import { servicedeskGettingStartedRequestTypesRoute } from '@jira/router-routes__servicedesk-getting-started-page-routes/src/servicedeskGettingStartedRequestTypesRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const gettingStartedRequestTypesPageEntryPoint = createPageEntryPoint({
	main: gettingStartedRequestTypesEntryPoint,
});

export const servicedeskGettingStartedRequestTypesRouteEntry: Route = createEntry(
	servicedeskGettingStartedRequestTypesRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		perfMetricKey: 'servicedesk-getting-started-request-types-load',
		skeleton: RequestTypesSkeleton,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			staticProjectSidebarNavigationResource,
			servicedeskIssueTypesResource,
			servicedeskPortalGroupsResource,
		],

		entryPoint: () =>
			fg('solution_composer_master') ? gettingStartedRequestTypesPageEntryPoint : undefined,

		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,

		bifrost: {
			bifrostGroup: 'shell-only',

			enabled: true,
		},
	}),
);
